// eslint-disable-next-line no-restricted-syntax
export enum Countries {
  /** United States */
  US = 'US',
  /** Canada */
  CA = 'CA',
}
